const inactiveStores = [
  '0444',
  '0448',
];

export default (storeId) => !inactiveStores.includes(storeId);
